const LAST_ACTIVITY_KEY = "last_activity_ts";
export const INACTIVITY_MS = 15 * 60 * 1000; // 15 minutes

export function touchActivity() {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
}

export function getLastActivity() {
  const v = localStorage.getItem(LAST_ACTIVITY_KEY);
  return v ? Number(v) : 0;
}

export function isInactiveTooLong() {
  const ts = getLastActivity();
  if (!ts) return true; // no record => treat as inactive
  return Date.now() - ts > INACTIVITY_MS;
}

export function clearActivity() {
  localStorage.removeItem(LAST_ACTIVITY_KEY);
}
